import Icon from '../components/Icon.vue'

Icon.register({"bed":{"width":576,"height":512,"paths":[{"d":"M552 288C565.3 288 576 298.7 576 312V448H480V384H96V448H0V88C0 74.7 10.7 64 24 64H72C85.3 64 96 74.7 96 88V288H552zM192 96C147.8 96 112 131.8 112 176S147.8 256 192 256 272 220.2 272 176 236.2 96 192 96zM576 224C576 171 533 128 480 128H312C298.7 128 288 138.7 288 152V256H576V224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bed.js
// module id = null
// module chunks = 